function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import Modal from '@mui/material/Modal';
import { Close as CloseIcon } from '@mui/icons-material';
import { colors } from '../../theme/index.js';
import Button from '../Button.js';
import Text from '../Text.js';
import Loader from '../Loader.js';
import ModalContent from '../ModalContent.js';
import ModalFilePreview from '../ModalFilePreview.js';
import { styled } from '@mui/system';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
const DropZoneWhitelabel = styled('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.primary.light,
  boxShadow: 'none',
  padding: '20px',
  border: `2px dotted ${theme.palette.primary.main}`,
  borderRadius: '8px',
  textAlign: 'center',
  color: theme.palette.primary.main
}));
import csvImage from '../../assets/csv.png';
import docImage from '../../assets/doc.png';
import imgImg from '../../assets/img.png';
import jsonImg from '../../assets/json.png';
import pdfImg from '../../assets/pdf.png';
import xlsImg from '../../assets/xls.png';
class DropZoneModal extends Component {
  state = {
    showContactModal: false,
    files: [],
    fileName: '',
    showDropzone: true
  };
  _chooseDocument = async files => {
    if (files[1] !== null) {
      files = new Array(files[0]);
    }
    const duplicate = this.state.files.length > 0 && this.state.files[0].name === files[0].name;
    if (!duplicate) {
      this.setState({
        fileName: files[0].name,
        files: [...this.state.files, ...files]
      });
    } else {
      // Use with Redux

      // this.props.dispatch(notifier.displayError({ verbiage: 'File already selected, please select a different file.' }));
      alert(i18n.t(tokens.labels.validations.fileAlreadySelected));
    }
    await this.setState({
      showDropzone: this.state.files.length < this.props.maxItems
    });
  };
  _fileType = file => {
    let fileType = null;
    switch (file.type) {
      case 'application/xlsx':
        fileType = xlsImg;
        break;
      case 'application/vnd.ms-excel':
        fileType = xlsImg;
        break;
      case 'text/csv':
        fileType = csvImage;
        break;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        fileType = docImage;
        break;
      case 'image/jpeg':
        fileType = imgImg;
        break;
      case 'image/jpg':
        fileType = imgImg;
        break;
      case 'image/png':
        fileType = imgImg;
        break;
      case 'application/json':
      case 'text/json':
        fileType = jsonImg;
        break;
      default:
        fileType = pdfImg;
        break;
    }
    return fileType;
  };
  _fileName = file => {
    let filename = null;
    file.name.length > 25 ? filename = `${file.name.substr(0, 11)}...${file.name.substr(-11)}` : filename = file.name;
    return filename;
  };
  _removeDocument = async name => {
    const fileArray = this.state.files.filter(file => file.name !== name);
    await this.setState({
      files: fileArray,
      showDropzone: true
    });
  };
  _submitDocument = async () => {
    if (this.state.files.length > 0) {
      const submit = await this.props.submitFile(this.state.files, this.props.type);
      this.props.hideModal();
      return submit;
    }
    return null;
  };
  render() {
    const {
      classes,
      showModal,
      hideModal,
      title,
      acceptedFiles,
      testid
    } = this.props;
    const {
      showDropzone
    } = this.state;
    const styles = {
      btnWidth: {
        width: 'fit-content',
        marginLeft: 'auto'
      },
      closeModalIcon: {
        cursor: 'pointer',
        display: 'inline',
        marginTop: '5px',
        fontSize: '22px',
        float: 'right',
        color: colors.mainTextGrey
      },
      titleIconWrapper: {
        display: 'flex',
        width: '100%',
        paddingBottom: '15px',
        verticalAlign: 'center',
        justifyContent: 'space-between'
      },
      cardStyle: {
        backgroundColor: colors.lightBlue,
        boxShadow: 'none',
        padding: '20px',
        border: `2px dotted ${colors.mediumBlue}`,
        borderRadius: '8px',
        textAlign: 'center',
        color: colors.mediumBlue
      },
      cardDisabled: {
        backgroundColor: colors.lightGrey,
        boxShadow: 'none',
        padding: '20px',
        border: `2px dotted ${colors.mediumLightGrey}`,
        borderRadius: '8px',
        color: colors.mediumLightGrey
      },
      previewWrapper: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginBottom: '10px',
        backgroundColor: colors.lightGrey,
        boxShadow: 'none',
        padding: '5px',
        borderRadius: '8px'
      },
      fileTitle: {
        maxWidth: '300px',
        wordBreak: 'break-all'
      },
      logo: {
        display: 'block',
        margin: '0 auto 10px',
        maxHeight: '220px',
        maxWidth: '350px',
        paddingBottom: '25px',
        paddingTop: '35px'
      }
    };
    return /*#__PURE__*/React.createElement(Modal, {
      open: showModal,
      onClose: hideModal,
      style: {
        overflow: 'auto',
        'WebkitOverflowScrolling': 'touch'
      }
    }, /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement("div", {
      style: styles.titleIconWrapper
    }, /*#__PURE__*/React.createElement(Text, {
      align: "center",
      bold: true,
      mediumLarge: true,
      display: "inline-block",
      margin: "0"
    }, title), /*#__PURE__*/React.createElement(CloseIcon, {
      sx: styles.closeModalIcon,
      onClick: hideModal
    })), this.state.files.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: styles.previewWrapper
    }, this.state.files.map(file => {
      const fileType = this._fileType(file);
      const fileName = this._fileName(file);
      return /*#__PURE__*/React.createElement(ModalFilePreview, {
        key: fileName
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        style: styles.closeModalIcon,
        onClick: () => this._removeDocument(file.name)
      }), /*#__PURE__*/React.createElement("img", {
        alt: "File type icon",
        src: fileType,
        style: styles.logo
      }), /*#__PURE__*/React.createElement(Text, {
        align: "center",
        bold: true,
        mediumLarge: true,
        display: "block",
        margin: "0",
        customStyle: {
          maxWidth: '300px'
        }
      }, fileName));
    }))), this.state.showDropzone && /*#__PURE__*/React.createElement(Dropzone, {
      onDrop: files => this._chooseDocument(files),
      accept: acceptedFiles || "image/png, image/jpeg, image/jpg, application/pdf, application/vnd.ms-excel, text/csv, text/json, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    }, ({
      getRootProps,
      getInputProps
    }) => /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DropZoneWhitelabel, _extends({}, getRootProps(), {
      sx: !showDropzone ? styles.cardDisabled : ""
    }), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(Text, {
      testid: testid,
      color: "primary",
      margin: "20px 0",
      small: true,
      align: "center"
    }, i18n.t(tokens.labels.employees.dragAndDropImagesHere))))), acceptedFiles && /*#__PURE__*/React.createElement(Text, {
      margin: "10px 0 0",
      align: "center",
      tiny: true
    }, acceptedFiles), /*#__PURE__*/React.createElement(Button, {
      disabled: this.state.files.length === 0,
      onClick: this._submitDocument,
      color: "primary",
      customStyle: styles.btnWidth,
      marginTop: "20px"
    }, i18n.t(tokens.buttons.submit)), this.props.loader?.isLoading && /*#__PURE__*/React.createElement(Loader, {
      isModal: true
    })));
  }
}
export default DropZoneModal;